<template>
  <div>
    <input type="hidden" :name="fieldName" :value="selectedColumnsOutput">

    <div class="row">

      <div class="col-lg-6">
        <div class="ibox table-bordered">
          <div class="ibox-title bg-muted text-center">
            Available Columns
          </div>
          <div class="ibox-content">
            <div v-if="availableColumns.length">
              <div class="alert alert-info text-center m-b-sm">
                Click to add to selected columns
              </div>

              <div class="list-group">
                <a v-for="column in availableColumns" type="button" class="list-group-item" @click="select(column)">
                  <i class="fa fa-plus-circle"></i> {{column.name}}
                </a>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-warning text-center m-b-xs">
                No available columns
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="ibox table-bordered">
          <div class="ibox-title bg-muted text-center">
            Selected Columns
          </div>
          <div class="ibox-content">
            <div v-if="selectedColumns.length">

              <div class="alert alert-info text-center m-b-sm">
                Click to remove from selected, drag to change order
              </div>

              <Sortable
                :list="selectedColumns"
                item-key="key"
                class="list-group draggable"
                @end="dragEnd"
              >
                <template #item="{element, index}">
                  <a type="button" class="list-group-item" :data-key="element.key" @click="unselect(element)">
                    <i class="fa fa-minus-circle"></i> {{element.name}}
                  </a>
                </template>
              </Sortable>

            </div>
            <div v-else>
              <div class="alert alert-warning text-center m-b-xs">
                No selected columns
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  /**
   * This component supposed to be used on filter management page, on "Columns" tab.
   * It makes easy to select columns to be displayed on filter result table and to
   * set order of those columns.
   */
  import { Sortable } from "sortablejs-vue3";

  export default {
    /**
     * Input properties.
     */
    props: {

      // Resulting form field name.
      fieldName: {
        type: String,
        default: 'columns',
      },

      // All columns.
      allColumns: {
        type: Array,
        default: () => []
      },

      // Initially selected columns.
      initiallySelectedColumns: {
        type: Array,
        default: () => []
      }
    },

    /**
     * Used components.
     */
    components: {
      Sortable
    },

    /**
     * Variables (models).
     */
    data () {
      return {
        // Selected columns.
        selectedColumns: []
      }
    },

    /**
     * Computed values
     */
    computed: {

      // Available columns.
      availableColumns: function () {
        return this.allColumns.filter(value => {
          return !this.selectedColumns.find(x => x.key === value.key);
        });
      },

      // String representation of selected column data.
      selectedColumnsOutput: function () {
        let columns = [];
        this.selectedColumns.forEach(value => columns.push(value.key));
        return JSON.stringify(columns);
      }
    },

    /**
     * Functions (methods).
     */
    methods: {

      // Update order.
      dragEnd(e) {
        const key = e.item.dataset.key;
        const column = this.selectedColumns.find(element => element.key === key);
        this.selectedColumns.splice(e.oldIndex, 1);
        this.selectedColumns.splice(e.newIndex, 0, column);
      },

      /**
       * Add column to selected column list.
       */
      select(column) {
        this.selectedColumns.push(column);
      },

      /**
       * Remove column from selected column list.
       */
      unselect(column) {
        this.selectedColumns = this.selectedColumns.filter(value => value.key !== column.key);
      },
    },

    /**
     * Initialize component on mount.
     */
    mounted () {
      // Add initially selected columns to selected column list.
      this.initiallySelectedColumns.forEach(value => this.select(value));
    }

  }
</script>

<style scoped>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    min-height: 20px;
  }
  .draggable .list-group-item {
    cursor: move;
  }
  .draggable .list-group-item i {
    cursor: pointer;
  }
</style>
